<template>
  <v-container fluid>
    <v-row align="center" v-for="item in points" :key="item.pointId">
      <v-col cols="12" sm="9">
        <v-text-field
          dense
          hide-details
          clearable
          :label="item.address"
          type="number"
          min="0"
          ref="quantity"
          :value="
            Object.keys(selectedOrderItems).length > 0 &&
            selectedOrderItems[product.lot + '.' + item.pointId] != null
              ? selectedOrderItems[product.lot + '.' + item.pointId].quantity
              : ''
          "
          @input="(value) => changeQuantity(product, item, value)"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="12" sm="5">
        <v-icon color="primary">{{ icons.mapMarker }}</v-icon>
        {{ item.address }}
      </v-col> -->
      <v-col cols="12" sm="3">
        <v-chip
          dark
          color="secondary"
          v-if="getState(item.pointId, product.productId).length > 0"
        >
          {{ getState(item.pointId, product.productId)[0].state }}
          <v-avatar right class="accent">
            {{ getState(item.pointId, product.productId)[0].quantity }}
          </v-avatar>
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

export default {
  props: {
    points: Array,
    product: Object,
    states: Array,
  },
  computed: {
    ...mapState({
      selectedOrderItems: (state) => state.orders.selectedOrderItems,
    }),
  },
  methods: {
    ...mapActions({
      updateSelectedOrderItems: "orders/UPDATE_SELECTED_ORDER_ITEMS",
      upsertBasket: "baskets/UPSERT_BASKET",
    }),
    changeQuantity: function (product, point, quantity) {
      if (quantity == null || quantity == "") quantity = 0;

      this.updateSelectedOrderItems({
        productId: product.productId,
        pointId: point.pointId,
        productName: product.name,
        manufacturer: product.manufacturer,
        productCountry: product.country,
        pointAddress: point.address,
        lot: product.lot,
        expiration: product.expiration,
        price: product.price,
        quantity,
      });

      this.upsertBasket({
        pointId: point.pointId,
        productId: product.productId,
        lot: product.lot,
        expiration: product.expiration,
        price: product.price,
        quantity,
      });
    },
    getState: function (pointId, productId) {
      return this.states.filter(
        (item) =>
          item.pointId === pointId &&
          item.productId === productId &&
          item.state !== "" &&
          item.state.toLowerCase() !== "доставлен" &&
          item.state.toLowerCase() !== "отменен"
      );
    },
  },
  data: () => ({
    icons: {
      mapMarker: Icon.mapMarker,
    },
  }),
  mounted: async function () {},
};
</script>
